import { StowageWrapper, ExtraButtonMenu, MenuItemButton } from '../PageHeader.styles';
import { useAuthStore } from '../../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStowageStore } from 'src/context/StowageContext';
import { Separator } from 'src/App.styles';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { getValueOrMax } from 'src/utils/stowage/stowageOperation/rotationCallStatusesUtils';
import { useEffect, useRef, useState } from 'react';
import { DropdownIcon, DropDownOptionsList, DropDownWrapper } from 'src/styles/dropDown.style';
import { stowageFeatureEnum } from 'src/enums/stowage/stowageFeatureEnum';
import { hasPermission } from 'src/utils/stowage/permissions/stowagePermissionsUtils';
import PageHeaderStowageCopy from './PageHeaderStowageCopy';
import useStowageQueryParamsUtils from 'src/utils/stowage/useStowageQueryParamsUtils';
import PageHeaderStowageRename from './PageHeaderStowageRename';
import { getNumberOfOpenSyncChanges } from 'src/utils/stowage/stowagePlanComparison/compareRotationUtilsV2';
import { getMasterStowagePlan, getNonMastertowagePlans, getStowagePlanType, sortStowagePlans } from 'src/utils/stowage/stowagePlanUtils';
import PageHeaderStowagePublishPromoteButton from './pageHeaderStowagePublishPromoteButton/PageHeaderStowagePublishPromoteButton';
import PageHeaderStowagePlanItem from './PageHeaderStowagePlanItem';
import PageHeaderStowagePlanListItem from './PageHeaderStowagePlanListItem';
import PageHeaderStowagePlanListGroup from './PageHeaderStowagePlanListGroup';
import PageHeaderStowagePrintPanel from './PageHeaderStowagePrintPanel';
import { RedIcon } from 'src/components/ui/status-icon/VerificationIcon.styles';
import { IconsWrapper, InvalidTankplan } from 'src/components/stowage/tankPlanView/TankPlanMenus/TankPlanTopMenu.styles';
import ViolationListIconComponent from 'src/components/stowage/violationListView/ViolationListIcon';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { useViolationsStore } from 'src/context/ViolationsContext';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';
import { useVesselStore } from 'src/context/VesselContext';
import { getViolationGroups } from 'src/utils/stowage/violations/violationGroups';
import { StowagePlanTypeEnum } from 'src/types/ViewModel/Stowage/Enums/StowagePlanTypeEnum';
import usePostStowageApi from 'src/api/stowage/usePostStowageApi';
import { StowagePlanActionToolbar, StowagePlanActionButton } from './PageHeaderStowage.style';
import { useRotationStore } from 'src/context/RotationContext';
import { PrimaryButton } from 'src/styles/button.style';
import CreateInitialMasterPlanPanel from 'src/components/stowage/common/CreateInitialMasterPlanPanel';
import { useToast } from 'src/app/useToast';

const PageHeaderStowageComponent = () => {
    const [showInvalidStowagePlan, setShowInvalidStowagePlan] = useState<boolean | null>(false);
    const { toastError } = useToast();
    const {
        isStowagePlanListMenuOpen,
        setIsStowagePlanListMenuOpen,
        triggerChangeLogProps,
        setTriggerChangeLogProps,
        isUtilizationOpen,
        setIsUtilizationOpen,
        stowagePlans,
        activeStowagePlan,
        isCopyStowagePlanMenuOpen,
        setIsCopyStowagePlanMenuOpen,
        isRenameStowagePlanMenuOpen,
        imosSyncChanges,
        setActiveStowagePlan,
        isPrintPanelOpen,
        setIsPrintPanelOpen,
        hasClosedOldStowagePlanModal,
        setHasClosedOldStowagePlanModal,
        setIsRenameStowagePlanMenuOpen,
        setStowagePlans,
        setStowageModalData,
    } = useStowageStore();
    const { role, loggedInUser } = useAuthStore();
    const { setQueryParamStowagePlan, clearQueryParamsStowagePlan } = useStowageQueryParamsUtils();
    const { updateStowagePlan } = usePostStowageApi();
    const { violations, isStowagePlanValid } = useViolationsStore();
    const softRuleViolationsCount = getViolationGroups(violations).filter(
        (group) => group.members[0].type === StowageRuleConsequenceType.SoftRule && group.status !== 'Accepted'
    ).length;
    const { setSelectedTab, setSelectedViolationListFilter } = useStowageSelectionStore();
    const { selectedVessel } = useVesselStore();
    const { imosRotationPortCallList } = useRotationStore();
    const masterPlanRef = useRef(null);
    const { setMouseClickPosition } = useStowageStore();

    const hasMasterPlan = stowagePlans?.some((sp) => !sp.isDeleted && sp.type === StowagePlanTypeEnum.Master) ?? false;
    const [isCreatePanelOpen, setIsCreatePanelOpen] = useState(false);

    useEffect(() => {
        const checkIfClickedOutside = (event) => {
            if (isStowagePlanListMenuOpen && masterPlanRef.current && !masterPlanRef.current.contains(event.target)) {
                setIsStowagePlanListMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', checkIfClickedOutside);

        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [isStowagePlanListMenuOpen]);

    useEffect(() => {
        if (selectedVessel) {
            setIsPrintPanelOpen(false);
        }
    }, [selectedVessel]);

    useEffect(() => {
        if (isStowagePlanValid !== null && isStowagePlanValid === true) {
            setShowInvalidStowagePlan(false);
        } else if (isStowagePlanValid !== null && isStowagePlanValid === false) {
            setShowInvalidStowagePlan(true);
        }
    }, [isStowagePlanValid]);

    const onOpenMasterPlanMenu = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setIsCopyStowagePlanMenuOpen(false);
        if (!isStowagePlanListMenuOpen) setIsStowagePlanListMenuOpen(true);
    };

    const onOpenChangeLog = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
        if (imosSyncChanges.length > 0) {
            setTriggerChangeLogProps(
                triggerChangeLogProps?.isChangeLogOpen
                    ? null
                    : {
                          isChangeLogOpen: true,
                          stowagePlanSyncChanges: imosSyncChanges,
                          shouldFilterClosedOrCompletedVoyages: true,
                          title: 'Updates from IMOS',
                          syncedDateTimeField: 'syncedWithImosDateTimeUtc',
                          shouldAddChanges: true,
                      }
            );
            setIsUtilizationOpen(false);
        }
        setMouseClickPosition({
            top: e.clientY,
            left: e.clientX,
        });
    };

    const onOpenUtilization = (e: any) => {
        setIsUtilizationOpen(!isUtilizationOpen);
        setTriggerChangeLogProps(null);
        setMouseClickPosition({
            top: e.clientY,
            left: e.clientX,
        });
    };

    const onOpenPrintPanel = (e: any) => {
        setIsUtilizationOpen(false);
        setTriggerChangeLogProps(null);
        setIsStowagePlanListMenuOpen(false);

        setIsPrintPanelOpen(!isPrintPanelOpen);
        setMouseClickPosition({
            top: e.clientY,
            left: e.clientX,
        });
    };

    const switchStowagePlan = (ev: any, stowagePlan: StowagePlan) => {
        ev.stopPropagation();

        const _stowagePlans = stowagePlans;
        if (!_stowagePlans || _stowagePlans.length === 0) {
            return;
        }

        setActiveStowagePlan(null);
        setIsStowagePlanListMenuOpen(false);
        if (hasClosedOldStowagePlanModal) setHasClosedOldStowagePlanModal(false);
        setQueryParamStowagePlan(stowagePlan.stowagePlanGuid);
    };

    const getStowagePlanTypeTitle = (stowagePlanType: string) => {
        const titles = {
            master: 'Master plan',
            published: 'Published plan',
            shared: 'Shared plan',
            draft: 'Draft plan',
        };

        return titles[stowagePlanType];
    };

    const onViewHardRuleViolations = (e: any) => {
        e.stopPropagation();
        e.preventDefault();

        setSelectedTab('Violation List');
        setSelectedViolationListFilter('All');
    };
    const numberOfOpenImosSyncChanges = getNumberOfOpenSyncChanges(imosSyncChanges);

    const hasHardRuleViolations = () => {
        return violations && violations.length > 0 && violations.some((violation) => violation.type === StowageRuleConsequenceType.HardRule);
    };

    const hasSoftRuleViolations = () => {
        return softRuleViolationsCount > 0;
    };

    const shouldShowInvalidStowagePlan = () => {
        return showInvalidStowagePlan && hasHardRuleViolations();
    };

    const shouldShowViolations = () => {
        return hasHardRuleViolations() || hasSoftRuleViolations();
    };

    const canCopyActivePlan = (): boolean => !!activeStowagePlan && hasPermission(role, stowageFeatureEnum.EditStowage);

    const canRenameActivePlan = (): boolean => {
        if (!activeStowagePlan) return false;
        const hasTypePermission =
            (activeStowagePlan.type === StowagePlanTypeEnum.Master && hasPermission(role, stowageFeatureEnum.Promote)) ||
            (activeStowagePlan.type === StowagePlanTypeEnum.Published && hasPermission(role, stowageFeatureEnum.Publish)) ||
            (activeStowagePlan.type === StowagePlanTypeEnum.Draft && hasPermission(role, stowageFeatureEnum.EditStowage));
        return hasPermission(role, stowageFeatureEnum.EditStowage) && hasTypePermission;
    };

    const canDeleteActivePlan = (): boolean =>
        !!activeStowagePlan &&
        hasPermission(role, stowageFeatureEnum.EditStowage) &&
        !activeStowagePlan.isNewStowagePlan &&
        activeStowagePlan.type === StowagePlanTypeEnum.Draft;

    const handleCopyActivePlan = (e: any): void => {
        e.stopPropagation();
        e.preventDefault();
        setIsCopyStowagePlanMenuOpen(!isCopyStowagePlanMenuOpen);
        setIsStowagePlanListMenuOpen(false);
    };

    const handleRenameActivePlan = (e: any): void => {
        e.stopPropagation();
        e.preventDefault();
        setIsRenameStowagePlanMenuOpen(!isRenameStowagePlanMenuOpen);
        setIsStowagePlanListMenuOpen(false);
    };

    const handleDeleteActivePlan = (e: any): void => {
        e.stopPropagation();
        e.preventDefault();
        if (!activeStowagePlan) return;
        setIsStowagePlanListMenuOpen(false);
        setStowageModalData({
            title: 'Delete stowage plan',
            message: `Are you sure you want to delete M${activeStowagePlan.masterPlanVersion} ${activeStowagePlan.title}?`,
            action: async () => {
                try {
                    const deletedPlan = { ...activeStowagePlan, isDeleted: true };
                    const { nextPlanGuid } = await updateStowagePlan(deletedPlan, true);
                    if (nextPlanGuid) {
                        setQueryParamStowagePlan(nextPlanGuid);
                    } else {
                        clearQueryParamsStowagePlan();
                    }
                } catch (error) {
                    toastError('Failed to delete stowage plan. Please try again.');
                } finally {
                    setStowageModalData(null);
                }
            },
            cancel: () => setStowageModalData(null),
            actionButtonText: 'Delete',
        });
    };

    const handleOpenCreatePanel = (e: any): void => {
        e.stopPropagation();
        e.preventDefault();
        setIsStowagePlanListMenuOpen(false);
        setIsCreatePanelOpen(true);
    };

    return (
        role &&
        hasPermission(role, stowageFeatureEnum.ViewStowagePlan) && (
            <>
                <StowageWrapper>
                    {isRenameStowagePlanMenuOpen && <PageHeaderStowageRename />}
                    {isCopyStowagePlanMenuOpen && <PageHeaderStowageCopy />}
                    {isPrintPanelOpen && <PageHeaderStowagePrintPanel onClose={() => setIsPrintPanelOpen(false)} />}
                    <DropDownWrapper width="400px" justify_content="left" onClick={(e) => onOpenMasterPlanMenu(e)}>
                        {activeStowagePlan &&
                            stowagePlans &&
                            (activeStowagePlan.isNewStowagePlan ? (
                                <span className="heading">No stowage plan</span>
                            ) : (
                                <span className="heading" title={getStowagePlanTypeTitle(getStowagePlanType(activeStowagePlan))}>
                                    <PageHeaderStowagePlanItem
                                        stowagePlan={activeStowagePlan}
                                        stowagePlanType={getStowagePlanType(activeStowagePlan)}
                                    />
                                </span>
                            ))}

                        {isStowagePlanListMenuOpen && stowagePlans && (
                            <DropDownOptionsList ref={masterPlanRef} width="400px" justify_content="left">
                                <li className="dd-heading" key="master-plan">
                                    Master Plan
                                </li>
                                <PageHeaderStowagePlanListItem
                                    stowagePlan={getMasterStowagePlan(stowagePlans)}
                                    onClick={switchStowagePlan}
                                    isSelected={activeStowagePlan?.stowagePlanGuid === getMasterStowagePlan(stowagePlans)?.stowagePlanGuid}
                                />
                                {!hasMasterPlan && role?.canEditGlobally === true && (
                                    <StowagePlanActionToolbar>
                                        <PrimaryButton onClick={handleOpenCreatePanel}>Create Initial Master Plan</PrimaryButton>
                                    </StowagePlanActionToolbar>
                                )}
                                <li className="separator"></li>
                                {hasPermission(role, stowageFeatureEnum.EditStowage) && (
                                    <StowagePlanActionToolbar>
                                        <StowagePlanActionButton
                                            onClick={handleCopyActivePlan}
                                            disabled={!canCopyActivePlan()}
                                            title="Copy stowage plan"
                                        >
                                            <FontAwesomeIcon icon="copy" /> Copy
                                        </StowagePlanActionButton>
                                        <StowagePlanActionButton
                                            onClick={handleRenameActivePlan}
                                            disabled={!canRenameActivePlan()}
                                            title="Rename stowage plan"
                                        >
                                            <FontAwesomeIcon icon="pen" /> Rename
                                        </StowagePlanActionButton>
                                        <StowagePlanActionButton
                                            isDanger
                                            onClick={handleDeleteActivePlan}
                                            disabled={!canDeleteActivePlan()}
                                            title="Delete stowage plan"
                                        >
                                            <FontAwesomeIcon icon="trash" /> Delete
                                        </StowagePlanActionButton>
                                    </StowagePlanActionToolbar>
                                )}
                                <li className="dd-heading">Stowage plans</li>
                                <PageHeaderStowagePlanListGroup
                                    stowagePlans={getNonMastertowagePlans(stowagePlans, loggedInUser?.userName)}
                                    onClick={switchStowagePlan}
                                    selectedPlanGuid={activeStowagePlan?.stowagePlanGuid}
                                />
                            </DropDownOptionsList>
                        )}
                    </DropDownWrapper>
                    <DropdownIcon onClick={(e) => onOpenMasterPlanMenu(e)}>
                        <FontAwesomeIcon icon="chevron-down" />
                    </DropdownIcon>
                    <ExtraButtonMenu>
                        <MenuItemButton onClick={(e) => onOpenUtilization(e)} title="Open ship utilization">
                            <FontAwesomeIcon icon="scale-unbalanced-flip" />
                        </MenuItemButton>
                        <MenuItemButton onClick={(e) => onOpenPrintPanel(e)} title="Generate a report" className={isPrintPanelOpen ? 'selected' : ''}>
                            <FontAwesomeIcon icon="print" />
                        </MenuItemButton>

                        {hasPermission(role, stowageFeatureEnum.SynchronizeWithImos) && (
                            <MenuItemButton
                                className={triggerChangeLogProps?.isChangeLogOpen ? 'selected' : ''}
                                onClick={(e) => onOpenChangeLog(e)}
                                title="Synchronize with IMOS"
                            >
                                <FontAwesomeIcon icon="sync-alt" />
                                {numberOfOpenImosSyncChanges > 0 ? (
                                    <RedIcon className="red-icon" title={'Incoming changes from IMOS'}>
                                        {getValueOrMax(numberOfOpenImosSyncChanges)}
                                    </RedIcon>
                                ) : (
                                    <></>
                                )}
                            </MenuItemButton>
                        )}
                        <Separator />
                        <PageHeaderStowagePublishPromoteButton />

                        {shouldShowViolations() && (
                            <InvalidTankplan className="invalid text-overflow" type="invalid" onClick={(e) => onViewHardRuleViolations(e)}>
                                {shouldShowInvalidStowagePlan() && <span className="show-text">Invalid stowage plan</span>}
                                {hasHardRuleViolations() && (
                                    <IconsWrapper type="invalid">
                                        <ViolationListIconComponent
                                            violationType={StowageRuleConsequenceType.HardRule}
                                            includeText={false}
                                            count={violations.filter((o) => o.type === StowageRuleConsequenceType.HardRule).length}
                                        />
                                    </IconsWrapper>
                                )}
                                {hasSoftRuleViolations() && (
                                    <IconsWrapper type="warning">
                                        <ViolationListIconComponent
                                            violationType={StowageRuleConsequenceType.SoftRule}
                                            includeText={false}
                                            count={softRuleViolationsCount}
                                        />
                                    </IconsWrapper>
                                )}
                            </InvalidTankplan>
                        )}
                    </ExtraButtonMenu>
                </StowageWrapper>
                {isCreatePanelOpen && selectedVessel && (
                    <CreateInitialMasterPlanPanel
                        imoNumber={selectedVessel.imoNumber}
                        vesselName={selectedVessel.vesselName}
                        defaultVoyageNumber={imosRotationPortCallList?.[0]?.voyageNumber ?? ''}
                        onClose={() => setIsCreatePanelOpen(false)}
                    />
                )}
            </>
        )
    );
};

export default PageHeaderStowageComponent;
